import React from 'react'
import { Link } from 'react-router';
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const Breadcrumb = ({name}) => {
  const location = useLocation();
  const canonicalPath = location.pathname.replace(/\/$/, '') || '/';

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://omsoftwares.in/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": name,
        "item": `https://omsoftwares.in${canonicalPath}`
      }
    ]
  };
  
  return (
    <>
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
    </Helmet>
    <nav aria-label="Breadcrumb">
    <section className="breadcrumb pt-105 pb-90">
    <div className="container">
        <div className="breadcrumb__content text-center">
            <h2 className="breadcrumb__title">{name}</h2>
            <ul className="breadcrumb__list">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item">{name}</li>
            </ul>
        </div>
    </div>
</section>
    </nav>
    </>
  )
}

export default Breadcrumb
